
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns-online/select-items",
      function () {
        return require("private-next-pages/returns-online/select-items/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns-online/select-items"])
      });
    }
  